export { WifiTemplate } from "./WifiTemplate";
export { useWifiData } from "./hooks";
